import {makeStyles} from "@material-ui/core/styles";

// Panel gorsel dili — Site Ayarlari ekraniyla ayni token'lar.
// Kanal renkleri dataviz kategorik sirasindan; renk korlugu ayrimi dogrulandi (ΔE 9.1).
export const CHANNEL_COLORS = ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#4a3aa7'];

const panelStyles = makeStyles((theme) => ({

    layout: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        paddingBottom: 60,
        minWidth: 0,
        [theme.breakpoints.down('sm')]: {
            gap: 14,
            paddingLeft: 14,
            paddingRight: 14,
        },
    },

    // --- Sayfa basligi ---
    pageHead: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        gap: 16,
        flexWrap: 'wrap',
    },
    pageEyebrow: {
        fontSize: 11.5,
        fontWeight: 600,
        letterSpacing: 0.9,
        textTransform: 'uppercase',
        color: '#8492a6',
        marginBottom: 6,
    },
    pageTitle: {
        margin: 0,
        fontSize: 27,
        fontWeight: 700,
        letterSpacing: -0.6,
        lineHeight: 1.15,
        color: '#16202f',
    },
    // --- Ay secici ---
    // Tek parca segment: ok / ay / ok. Ortadaki dugme takvimi acar.
    rangeNav: {
        display: 'inline-flex',
        alignItems: 'stretch',
        background: '#fff',
        border: '1px solid #e3e8f1',
        borderRadius: 999,
        boxShadow: '0 1px 2px rgba(22, 32, 47, 0.04)',
        overflow: 'hidden',
    },
    rangeArrow: {
        border: 0,
        background: 'transparent',
        cursor: 'pointer',
        padding: '0 13px',
        color: '#8492a6',
        fontSize: 12,
        lineHeight: 1,
        transition: 'background 0.15s ease, color 0.15s ease',
        '&:hover:not(:disabled)': {background: '#f2f5fa', color: '#16202f'},
        '&:disabled': {color: '#cfd7e3', cursor: 'default'},
        '&:focus': {outline: 'none'},
    },
    rangeChip: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        border: 0,
        borderLeft: '1px solid #eef1f6',
        borderRight: '1px solid #eef1f6',
        background: 'transparent',
        cursor: 'pointer',
        padding: '8px 15px',
        fontFamily: 'inherit',
        fontSize: 12.5,
        color: '#5b6675',
        whiteSpace: 'nowrap',
        transition: 'background 0.15s ease',
        '&:hover': {background: '#f2f5fa'},
        '&:focus': {outline: 'none'},
        '& b': {color: '#16202f', fontWeight: 600},
        '& i': {fontSize: 13, color: '#8492a6'},
    },
    // Sagda baska segment yokken cift cizgi olmasin
    rangeChipEnd: {borderRight: 0},
    // Bugun disina cikildiginda: donemin canli olmadigini soyleyen kucuk isaret
    rangeToday: {
        border: 0,
        background: 'transparent',
        cursor: 'pointer',
        padding: '0 13px',
        fontFamily: 'inherit',
        fontSize: 12,
        fontWeight: 600,
        color: '#d71f26',
        whiteSpace: 'nowrap',
        transition: 'background 0.15s ease',
        '&:hover': {background: '#f2f5fa'},
        '&:focus': {outline: 'none'},
    },

    // --- "Su an" kartlari: bugunun operasyonel ozeti ---
    tiles: {
        display: 'grid',
        gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
        gap: 12,
        [theme.breakpoints.down('md')]: {gridTemplateColumns: 'repeat(3, minmax(0, 1fr))'},
        [theme.breakpoints.down('xs')]: {gridTemplateColumns: 'repeat(2, minmax(0, 1fr))'},
    },
    tile: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        background: '#fff',
        border: '1px solid #e3e8f1',
        boxShadow: '0 1px 2px rgba(22, 32, 47, 0.04)',
        borderRadius: 16,
        padding: '24px 15px',
        minWidth: 0,
    },
    tileIcon: {
        flex: 'none',
        width: 40,
        height: 40,
        borderRadius: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 15,
    },
    // Renk anlami destekler, tek basina tasimaz: etiket her kartta yazili
    toneIn: {background: '#e6f4ec', color: '#157f4f'},
    toneOut: {background: '#eef2f8', color: '#5b6675'},
    toneNew: {background: '#fdeced', color: '#d71f26'},
    toneMoney: {background: '#fdeced', color: '#d71f26'},
    toneCancel: {background: '#fdf1de', color: '#a86200'},
    tileBody: {minWidth: 0},
    tileLabel: {
        fontSize: 11,
        fontWeight: 650,
        letterSpacing: 0.7,
        textTransform: 'uppercase',
        color: '#8492a6',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    tileValue: {
        marginTop: 4,
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: 24,
        fontWeight: 600,
        letterSpacing: -0.7,
        lineHeight: 1,
        color: '#16202f',
        fontVariantNumeric: 'tabular-nums',
        '& small': {fontSize: 12.5, fontWeight: 600, color: '#8492a6', marginLeft: 4},
    },
    tileSub: {marginTop: 5, fontSize: 11.5, color: '#8492a6'},

    // --- Donem ozeti: ciro basta, digerleri izgarada ---
    sumHero: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 18,
        flexWrap: 'wrap',
    },
    sumHeroLabel: {fontSize: 12.5, color: '#8492a6'},
    sumHeroValue: {
        marginTop: 4,
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: 32,
        fontWeight: 600,
        letterSpacing: -1,
        lineHeight: 1,
        color: '#d71f26',
        fontVariantNumeric: 'tabular-nums',
    },
    sumHeroSide: {marginLeft: 'auto', textAlign: 'right'},
    sumHeroCount: {
        marginTop: 4,
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: 26,
        fontWeight: 600,
        letterSpacing: -0.8,
        lineHeight: 1,
        color: '#16202f',
        fontVariantNumeric: 'tabular-nums',
    },
    sumGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gap: 10,
        marginTop: 20,
    },
    sumBox: {
        background: '#f7f9fc',
        border: '1px solid #eef1f6',
        borderRadius: 12,
        padding: '11px 13px',
        minWidth: 0,
    },
    sumBoxLabel: {fontSize: 11.5, color: '#8492a6', lineHeight: 1.3},
    sumBoxValue: {
        marginTop: 5,
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: 17,
        fontWeight: 600,
        letterSpacing: -0.3,
        lineHeight: 1,
        color: '#16202f',
        fontVariantNumeric: 'tabular-nums',
    },
    sumBoxSub: {marginTop: 4, fontSize: 11, color: '#8492a6'},

    // --- Trend grafigi ---
    chartWrap: {
        position: 'relative',
        cursor: 'crosshair',
        flex: 1,
        minHeight: 150,
    },
    chartTip: {
        position: 'absolute',
        zIndex: 2,
        pointerEvents: 'none',
        background: '#fff',
        border: '1px solid #e3e8f1',
        borderRadius: 10,
        boxShadow: '0 6px 20px rgba(22, 32, 47, 0.12)',
        padding: '8px 11px',
        whiteSpace: 'nowrap',
        lineHeight: 1.35,
        '& b': {
            display: 'block',
            fontSize: 12.5,
            fontWeight: 650,
            color: '#16202f',
        },
        '& span': {
            display: 'block',
            marginTop: 2,
            fontSize: 12,
            color: '#5b6675',
            fontVariantNumeric: 'tabular-nums',
        },
    },

    // --- Kart ---
    // Trend karti: grid satirinda komsusuyla ayni yuksekliğe geriliyor, grafik
    // sabit yukseklikte kalinca altinda bosluk olusuyordu. Kart ve govde dikey
    // flex; grafik kalan alani doldurur.
    cardFill: {display: 'flex', flexDirection: 'column'},
    cardBodyFill: {display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0},
    dividerFill: {display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0},

    card: {
        background: '#fff',
        border: '1px solid #e3e8f1',
        borderRadius: 16,
        boxShadow: '0 1px 2px rgba(22, 32, 47, 0.04)',
        overflow: 'hidden',
        minWidth: 0,
    },
    cardHead: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '15px 18px',
        borderBottom: '1px solid #eef1f6',
        flexWrap: 'wrap',
    },
    cardTitle: {margin: 0, fontSize: 15, fontWeight: 700, letterSpacing: -0.15, color: '#16202f'},
    cardDesc: {margin: '2px 0 0', fontSize: 12, color: '#8492a6'},
    cardNote: {marginLeft: 'auto', fontSize: 12.5, color: '#8492a6'},
    cardBody: {padding: 18},

    // --- Ana ikili duzen ---
    main: {
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1.55fr) minmax(0, 1fr)',
        gap: 16,
        [theme.breakpoints.down('md')]: {gridTemplateColumns: 'minmax(0, 1fr)'},
    },

    // --- Doluluk ---
    occRow: {display: 'flex', alignItems: 'flex-end', gap: 18, flexWrap: 'wrap'},
    occNumber: {
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: 56,
        fontWeight: 600,
        letterSpacing: -2,
        lineHeight: 0.9,
        fontVariantNumeric: 'tabular-nums',
        color: '#d71f26',
        '& span': {fontSize: 24, color: '#8492a6'},
    },
    occMeta: {paddingBottom: 5},
    occKey: {fontSize: 12.5, color: '#8492a6'},
    occValue: {fontSize: 13.5, fontWeight: 600, marginTop: 2, fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace'},

    // --- Kanal tablosu ---
    chanHead: {
        display: 'grid',
        gridTemplateColumns: '150px minmax(0, 1fr) 104px 108px 92px 92px',
        gap: 14,
        alignItems: 'end',
        padding: '0 18px 10px',
        fontSize: 10.5,
        fontWeight: 700,
        letterSpacing: 0.9,
        textTransform: 'uppercase',
        color: '#8492a6',
        [theme.breakpoints.down('xs')]: {display: 'none'},
    },
    chanRow: {
        display: 'grid',
        gridTemplateColumns: '150px minmax(0, 1fr) 104px 108px 92px 92px',
        gap: 14,
        alignItems: 'center',
        padding: '11px 18px',
        borderTop: '1px solid #eef1f6',
        '&:hover': {background: '#fbfcfe'},
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: '110px minmax(0, 1fr) 92px 96px 82px 82px',
        },
        // Telefonda sutunlar sigmiyor: ad+adet ustte, bar ortada, ciro altta
        [theme.breakpoints.down('xs')]: {
            gridTemplateColumns: 'minmax(0, 1fr) auto',
            gridTemplateAreas: '"name count" "bar bar" "rev rev"',
            gap: '7px 12px',
        },
    },
    chanName: {
        display: 'flex',
        alignItems: 'center',
        gap: 9,
        minWidth: 0,
        fontSize: 13.5,
        fontWeight: 650,
        color: '#16202f',
        [theme.breakpoints.down('xs')]: {gridArea: 'name'},
    },
    // Kirpma ic span'da: flex kapsayicida text-overflow calismiyor,
    // ad uc noktasiz kesiliyordu.
    chanNameText: {
        minWidth: 0,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    chanTip: {
        position: 'fixed',
        zIndex: 1400,
        transform: 'translate(-50%, -100%)',
        pointerEvents: 'none',
        background: '#fff',
        border: '1px solid #e3e8f1',
        borderRadius: 8,
        boxShadow: '0 6px 20px rgba(22, 32, 47, 0.14)',
        padding: '8px 11px',
        maxWidth: 300,
        fontSize: 12.5,
        fontWeight: 600,
        lineHeight: 1.4,
        color: '#16202f',
        textAlign: 'left',
    },
    dot: {width: 9, height: 9, borderRadius: 3, flexShrink: 0, display: 'block'},
    track: {
        height: 9,
        borderRadius: 999,
        background: '#f7f9fc',
        overflow: 'hidden',
        [theme.breakpoints.down('xs')]: {gridArea: 'bar'},
    },
    trackFill: {display: 'block', height: '100%', borderRadius: 999},
    numCell: {
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: 13.5,
        fontVariantNumeric: 'tabular-nums',
        textAlign: 'right',
        color: '#16202f',
        '& small': {color: '#8492a6', fontSize: 11.5, marginLeft: 3},
    },
    chanCount: {[theme.breakpoints.down('xs')]: {gridArea: 'count'}},
    chanRevenue: {[theme.breakpoints.down('xs')]: {gridArea: 'rev', textAlign: 'left'}},
    // Turetilmis iki sutun telefonda gizlenir: alti sutun ekrana sigmiyor
    chanAbv: {color: '#8492a6', [theme.breakpoints.down('xs')]: {display: 'none'}},
    chanAdr: {color: '#8492a6', [theme.breakpoints.down('xs')]: {display: 'none'}},

    // --- Son rezervasyonlar ---
    feed: {
        maxHeight: 372,
        overflowY: 'auto',
        '&::-webkit-scrollbar': {width: 5},
        '&::-webkit-scrollbar-thumb': {background: '#d3dae4', borderRadius: 4},
        '&::-webkit-scrollbar-track': {background: 'transparent'},
    },
    res: {
        display: 'grid',
        gridTemplateColumns: '34px minmax(0, 1fr) auto',
        gap: 12,
        padding: '12px 18px',
        borderBottom: '1px solid #eef1f6',
        alignItems: 'start',
        textDecoration: 'none',
        color: 'inherit',
        '&:last-child': {borderBottom: 'none'},
        '&:hover': {background: '#fbfcfe'},
    },
    resBadge: {
        width: 34,
        height: 34,
        borderRadius: 10,
        display: 'grid',
        placeItems: 'center',
        fontSize: 11,
        fontWeight: 700,
        color: '#fff',
    },
    resName: {
        fontSize: 13.5,
        fontWeight: 650,
        color: '#16202f',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    resMeta: {
        marginTop: 3,
        fontSize: 12,
        color: '#8492a6',
        display: 'flex',
        gap: 8,
        flexWrap: 'wrap',
        alignItems: 'center',
    },
    resSep: {color: '#c9d2de'},
    resSide: {textAlign: 'right', whiteSpace: 'nowrap'},
    resTotal: {
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: 13.5,
        fontWeight: 600,
        fontVariantNumeric: 'tabular-nums',
        color: '#16202f',
    },
    resTotalCancelled: {color: '#8492a6', textDecoration: 'line-through'},
    resTime: {
        marginTop: 3,
        fontSize: 11.5,
        color: '#8492a6',
        // moment.fromNow() kucuk harfle geliyor ("bir gun once"); diger kucuk
        // metinler gibi buyuk harfle bassin. capitalize kullanilmiyor: her
        // kelimeyi buyutup "Bir Gun Once" yapardi.
        '&::first-letter': {textTransform: 'uppercase'},
    },

    // --- Rozet ---
    pill: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        fontSize: 11,
        fontWeight: 650,
        padding: '2px 8px',
        borderRadius: 999,
        whiteSpace: 'nowrap',
    },
    pillOk: {background: '#e6f4ec', color: '#157f4f'},
    pillWarn: {background: '#fdf1de', color: '#a86200'},
    pillOff: {background: '#eef1f6', color: '#8a95a5'},
    pillDot: {width: 5, height: 5, borderRadius: '50%', background: 'currentColor', display: 'block'},

    // --- Musaitlik ---
    horizon: {display: 'flex', alignItems: 'baseline', gap: 12, flexWrap: 'wrap'},
    horizonBig: {
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: 26,
        fontWeight: 600,
        letterSpacing: -0.5,
        fontVariantNumeric: 'tabular-nums',
        color: '#16202f',
        marginTop: 3,
        '& span': {fontSize: 16, color: '#8492a6'},
    },
    // --- Musaitlik takvimi: uc ay yan yana ---
    calMonths: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
        gap: 26,
        [theme.breakpoints.down('md')]: {gridTemplateColumns: 'repeat(2, minmax(0, 1fr))'},
        [theme.breakpoints.down('xs')]: {gridTemplateColumns: 'minmax(0, 1fr)'},
    },
    calMonth: {minWidth: 0},
    calMonthName: {
        fontSize: 13,
        fontWeight: 650,
        color: '#16202f',
        marginBottom: 9,
    },
    calWeekHead: {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
        gap: 4,
        fontSize: 10,
        fontWeight: 650,
        letterSpacing: 0.4,
        textTransform: 'uppercase',
        color: '#a3aec0',
        textAlign: 'center',
        marginBottom: 5,
    },
    calGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
        gap: 4,
    },
    calPad: {display: 'block'},
    calDay: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 38,
        borderRadius: 8,
        border: '1px solid transparent',
        fontVariantNumeric: 'tabular-nums',
        '& b': {
            fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
            fontSize: 12.5,
            fontWeight: 600,
            lineHeight: 1,
        },
        // Istisna notu: yalnizca kismen/tamamen kapali gunlerde yazilir
        '& i': {
            fontStyle: 'normal',
            fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
            fontSize: 9.5,
            marginTop: 2,
            opacity: 0.85,
        },
    },
    calOpen: {background: '#e6f4ec', borderColor: '#cdeadb', color: '#12613e'},
    calPartial: {background: '#fdf1de', borderColor: '#fbe6c2', color: '#8a5000'},
    calClosed: {background: '#f1f4f9', borderColor: '#dde3ec', color: '#8492a6'},
    calNoData: {borderColor: '#eef1f6', borderStyle: 'dashed', color: '#c3cbd8'},
    // Gecmis gunler soluk: karar verilecek gunler one ciksin
    calPast: {opacity: 0.45},
    calToday: {
        boxShadow: '0 0 0 2px #d71f26',
        borderColor: 'transparent',
    },
    // Aciklama gerektiren metrik etiketi: yaninda kucuk bir soru isareti
    hintAnchor: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        cursor: 'help',
        '& i': {fontSize: 11.5, color: '#b3bccb', transition: 'color 0.15s ease'},
        '&:hover i': {color: '#5b6675'},
    },

    // Takvim ipucu: position fixed — kartin overflow:hidden'i kirpmasin
    calTip: {
        position: 'fixed',
        zIndex: 1400,
        transform: 'translate(-50%, -100%)',
        pointerEvents: 'none',
        background: '#fff',
        border: '1px solid #e3e8f1',
        borderRadius: 10,
        boxShadow: '0 6px 20px rgba(22, 32, 47, 0.14)',
        padding: '8px 11px',
        maxWidth: 300,
        lineHeight: 1.4,
        '& b': {display: 'block', fontSize: 12.5, fontWeight: 650, color: '#16202f'},
        '& span': {display: 'block', marginTop: 2, fontSize: 12, color: '#5b6675'},
        '& em': {display: 'block', marginTop: 3, fontSize: 11.5, fontStyle: 'normal', color: '#a86200'},
    },
    legend: {display: 'flex', gap: 14, marginTop: 16, fontSize: 11.5, color: '#8492a6', flexWrap: 'wrap'},
    legendItem: {display: 'inline-flex', alignItems: 'center', gap: 5},
    legendSwatch: {width: 9, height: 9, borderRadius: 3, display: 'block'},

    // --- Ortak ---
    loadingBox: {display: 'flex', alignItems: 'center', justifyContent: 'center', padding: theme.spacing(6, 3)},
    emptyBox: {padding: '26px 18px', textAlign: 'center', fontSize: 13, color: '#8492a6'},
    divider: {marginTop: 22, paddingTop: 18, borderTop: '1px solid #eef1f6'},
    sparkLabels: {
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: 11.5,
        color: '#8492a6',
        paddingTop: 6,
    },
}));

export default panelStyles;
